module.exports = __webpack_public_path__ + "img/salud-mayores.c1ec2af4.png";